import React, { useState } from "react";
import { StackedProgress } from "../../ui/stacked-progress";
import { Typography, Button } from "@mui/material";

//Icons
import { ReactComponent as StreakIcon } from "../../../assets/icons/svg/fire-flame.svg";
import { ReactComponent as LinkIcon } from "../../../assets/icons/svg/link.svg";

//Chart
import MacroCompoundBarChart from "../../charts/MacroCompoundBarChart";

//Modals
import SingleMacroModal from "../modals/SingleMacroModal";
import CustomModal from "../../modal/CustomModal";

const MacroItem = ({ macroData: { macro, amount, streak, target }, date }) => {
  const [showExpandedModal, setShowExpandedModal] = useState(false);

  return (
    <div className="auto-fill-minmax-300 p-4 border-t md:border border-separator flex-col md:rounded-md shadow-sm bg-background">
      <CustomModal
        open={showExpandedModal}
        type="bottomToCentered"
        handleClose={() => setShowExpandedModal(false)}
        contentClassNameOverride="min-h-fit"
      >
        <SingleMacroModal macro={macro} date={date} />
      </CustomModal>
      <div className="w-full flex flex-row justify-between items-center">
        <Button
          className="flex flex-row items-center justify-start gap-2 p-0 hover:bg-transparent"
          onClick={() => setShowExpandedModal(true)}
          disableRipple
        >
          <Typography variant="subtitle1">{macro.name}</Typography>
          <LinkIcon className="h-[0.625rem] w-auto fill-secondaryText-600" />
        </Button>

        <div className="flex flex-row gap-1 items-center w-fit">
          <StreakIcon className="h-[0.825rem] w-auto fill-complementaryRed" />
          <Typography variant="subtitle2" className="text-secondaryText-700 leading-none font-medium">
            <span className="font-medium text-sm">{streak ? streak : 0}</span>
          </Typography>
        </div>
      </div>
      <div className="mt-6">
        <Button
          className="flex flex-col gap-2 cursor-pointer hover:bg-transparent w-full p-0 items-start"
          onClick={() => setShowExpandedModal(true)}
          disableRipple
        >
          <div></div>
          {target ? (
            <>
              <Typography variant="subtitle1" className="font-light">
                {amount.value}/{amount.value > 0 ? amount.value : 1}
                {` ${amount.unit.name}`}
              </Typography>
              <StackedProgress
                segments={[
                  {
                    value: (amount.value / amount.value > 0 ? amount.value : 1) * 100,
                    color: macro.name.toLowerCase() === "water" ? "bg-mainBlue-400" : "",
                  },
                ]}
              />
            </>
          ) : (
            <>
              <Typography variant="subtitle1" className="font-light">
                {amount.value % 1 === 0 ? amount.value.toFixed(0) : amount.value.toFixed(2)}
                {` ${amount.unit.name}`}
              </Typography>
              <StackedProgress
                segments={[
                  {
                    value: amount?.value > 0 ? (amount.value / amount.value) * 100 : 0,
                    color: macro.name.toLowerCase() === "water" ? "bg-mainBlue-400" : "",
                  },
                ]}
              />
            </>
          )}
        </Button>

        {false && (
          <div className="mt-2">
            <Typography variant="caption">{`${Math.round(
              (amount.value / target.value) * 100
            )}% of your goal`}</Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default MacroItem;
